module.exports="cbawebpack"


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/module-description-file/~/testloader/lib/loader.webpack-loader.js!./loaders/module-description-file/reverseloader.js!./loaders/_resources/abc.txt
 ** module id = 5
 ** module chunks = 0
 **/